import { queueKey } from "./global/globals";
const notExistsIndex = -1;
const countToDelete = 1;
const unsubscribeEvent = (item) => {
  const callbacks = window[queueKey] ?? [];
  const index = callbacks.indexOf(item);
  if (index > notExistsIndex) {
    callbacks.splice(index, countToDelete);
  }
};
var unsubscribeEvent_default = unsubscribeEvent;
export {
  unsubscribeEvent_default as default
};
